import React from 'react';
import { connect } from 'react-redux';

import ForgottenPasswordForm from '../../forms/ForgottenPassword';
import PageHeader from '../../modules/PageHeader';
import PageMeta from '../../modules/PageMeta';
import PageSection from '../../modules/PageSection';
import SidebarColumn from '../../modules/SidebarColumn';
import ContentColumn from '../../modules/ContentColumn';
import PageSidebar from '../../modules/PageSidebar';
import AlertBox from '../../modules/AlertBox';
import Page from '../../pages/Page';
import ReferrerLink from '../../modules/ServiceReferrerLink';

import * as resetActions from '../../../actions/password_reset';
import * as serviceActions from '../../../actions/services';
import qs from "query-string";
import AlertMessage from "../../modules/AlertMessage/index";

class ForgottenPassword extends React.Component {

    constructor() {
        super();

        this._submit = this._submit.bind(this);
    }

    componentDidMount() {
        this.props.initialiseResetForm();

        const serviceId = this._getQueryParams().service;

        this.props.refreshServiceReferrer(serviceId);
    }

    _getQueryParams() {
        return qs.parse(this.props.location.search);
    }

    _submit(values) {

        if (this.props.serviceReferrer) {
            return this.props.sendPasswordReset(values.email, this.props.serviceReferrer.id);
        } else {
            return this.props.sendPasswordReset(values.email);
        }
    }

    render() {

        const { showConfirmation, serviceReferrer } = this.props;

        const showServiceReferrer = !!this._getQueryParams().service;

        return (
            <Page>
                <PageMeta title="Forgotten Password" />

                <SidebarColumn>
                    <PageSidebar />
                </SidebarColumn>

                <ContentColumn>
                    <PageHeader>
                        <h1>Forgotten Password</h1>

                        <span>If you have forgotten your password, you can receive a password reset email through the sender below.</span>
                    </PageHeader>

                    {showServiceReferrer && serviceReferrer &&
                        <PageSection>
                            <ReferrerLink service={serviceReferrer} />
                        </PageSection>
                    }

                    <PageSection>

                        <AlertMessage>
                            {showConfirmation &&
                                <AlertBox theme="success">
                                    A 'Reset your password' email has been sent to your email address. This will contain instructions on how to reset your password.
                                    <br /><br />
                                    This email may be in your spam folder.
                                </AlertBox>
                            }
                        </AlertMessage>

                        {!showConfirmation &&
                            <ForgottenPasswordForm onSubmit={this._submit}/>
                        }

                    </PageSection>

                </ContentColumn>
            </Page>
        )
    }
}

const mapStateToProps = state => {
    return {
        isLoggedIn: !!state.session.user,
        showConfirmation: !!state.passwordReset.resetEmailSentTo,
        email: state.passwordReset.resetEmailSentTo,
        serviceReferrer: state.services.serviceReferrer
    }
};

const mapDispatchToProps = dispatch => {
    return {
        refreshServiceReferrer(serviceId) {
            dispatch(serviceActions.refreshServiceReferrer(serviceId));
        },
        sendPasswordReset(email, serviceReferrerId = null) {
            return dispatch(resetActions.sendPasswordResetEmail(email, serviceReferrerId));
        },
        initialiseResetForm() {
            dispatch(resetActions.passwordResetSent(null));
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ForgottenPassword);
